import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { AppSettings } from '../../../../app.settings'; //This is my Constant Service
import { LoopBackAuth } from '../../../../shared/sdk/services/core/auth.service';
import { LoopBackFilter } from '../../../../shared/sdk/models/';
import { MenuitemApi } from '../../../../shared/sdk/services/custom';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';

@Component({
    selector: 'topbar-menu',
    templateUrl: './topbar-menu.component.html',
    styleUrls: ['./topbar-menu.component.scss'],
    providers: [AppSettings, MenuitemApi]
    /*
     template: `
     <template ngFor let-link [ngForOf]="links" let-last = last>
         <li class="link-item" *ngIf="link.label.title" [ngClass]="{active: last}">
         <a *ngIf="!last" [routerLink]="link.url">{{link.label.title}}</a>
         <span *ngIf="last" [routerLink]="link.url">{{link.label.title}}</span>
     </template>`*/
})
export class TopBarMenuComponent {
    links: Array<Object>;
    pagevalues;
    appId;
    apptype;
    userdata;
    menuitems;
    notifyOptions = PlatformApp.getNotificationOptions();
    menuitemFilter: LoopBackFilter = <LoopBackFilter>{
        'where': {}
    };

    constructor(private router: Router, private route: ActivatedRoute,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private MenuitemApi: MenuitemApi, private AppSettings: AppSettings, private auth: LoopBackAuth) {
    }
    ngOnInit(): void {
        this.setAppType();
        this.setMenuItems();

        this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
            this.links = [];
            let currentRoute = this.route.root,
                url = '';

            do {
                let childrenRoutes = currentRoute.children;

                currentRoute = null;
                childrenRoutes.forEach(route => {
                    if (route.outlet === 'primary') {
                        let routeSnapshot = route.snapshot;
                        url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                        this.links.push({
                            label: route.snapshot.data,
                            url: url
                        });

                        currentRoute = route;
                    }
                })
            } while (currentRoute);
            this.pagevalues = this.links[this.links.length - 1];
        });
    }

    private setAppType(): void {
        /*
        For the time being , set the below apptypes
        sarfraz@ampcome.com - apptype=0,
        admin@tim.com - apptype=1,
         admin@gokhana.com - apptype=2, 
        
        */
        //Set the default apptype;
        this.apptype = this.AppSettings.APPTYPE;
        this.userdata = this.auth.getCurrentUserData();
        if (this.userdata && this.userdata.email) {
            if (this.userdata.email === 'sarfraz@ampcome.com') {
                this.apptype = '0';
            } else if (this.userdata.email === 'arun@ampcome.com') {
                this.apptype = '0';
            } else if (this.userdata.email === 'admin@gokhana.com') {
                this.apptype = '2';
            } else if (this.userdata.email === 'admin@tim.com') {
                this.apptype = '1';
            } else if (this.userdata.email === 'admin@yalienergy.com') {
                this.apptype = '3';
            } else this.apptype = '2';
        }
    }

    private setMenuItems(): void {
        if (this.userdata && this.userdata.appId) {
            this.menuitemFilter.where["appId"] = this.userdata.appId;
            this.menuitemFilter.where["accesslevel"] = this.userdata.accounttype;
            this.menuitemFilter.order = "index";

            this.MenuitemApi.find(this.menuitemFilter).subscribe((results) => {
                this.menuitems = results;
                for (var i = 0; i < this.menuitems.length; i++) {
                    if (this.menuitems[i].submenu && this.menuitems[i].submenu.length && this.menuitems[i].submenu.length > 0) {
                        this.menuitems[i].isdropdown = true;
                    }
                    else {
                        this.menuitems[i].isdropdown = false;
                    }
                }
            });
        } else {
            this.menuitems = [];
        }
    }
    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/topbar/topbar-menu.component.ts